export default __webpack_public_path__ + "static/media/sites-mob15.c423a196.png";